import { msg } from '@omegagrid/localize';
import { FormAdapter, FormAlert, FormContainerOptions, FormControlProperties, FormControlType, FormValues } from '@omegagrid/form';
import rp from '@reporting/rp-app-host';
import { DeploymentThreadTypes, Thread } from '@reporting/rp-types/deployment';
import { THREAD_TYPES } from '../types';

export class ThreadFormAdapter extends FormAdapter {

	private command_txt: string; // in case of duplicate
	private doc_txt: string; // in case of duplicate
	private thread: Thread;

	constructor(
		private idThread: number = null,
		private duplicate: boolean = false,
	) { super() }

	getColumns() {
		return [
			{width: 80},
			{width: null},
		];
	}

	async getControls() {
		this.thread = this.idThread ? (await rp.ms('deployment').get<Thread>(`threads/${this.idThread}`)) : {};
		if (this.duplicate) {
			this.thread.description = `${this.thread.description}_copy`;
			this.idThread = null;
			this.command_txt = this.thread.command_txt;
			this.doc_txt = this.thread.doc_txt;
		}
		
		const controls: FormControlProperties[] = [
			{ row: 0, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'description' },
			{ row: 0, col: 1, type: FormControlType.TextInput, key: 'description', value: this.thread.description, required: true },
			{ row: 1, col: 0, type: FormControlType.Label, value: msg('Type'), for: 'type' },
			{ row: 1, col: 1, type: FormControlType.List, key: 'type', required: true, value: this.thread.type || DeploymentThreadTypes.Custom, content: {
				sourceData: THREAD_TYPES, options: { selectMode: 'single', autoClose: true }
			}}
		];

		return controls;
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null, //'Form1',
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: ["save", "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		const thread: Thread = {
			idz: this.thread?.idz || null,
			description: formValues.description as string,
			type: formValues.type as DeploymentThreadTypes,
			enabled: 1,
		};
		if (this.duplicate) {
			if (this.command_txt) thread.command_txt = this.command_txt;
			if (this.doc_txt) thread.doc_txt = this.doc_txt;
		}
		await rp.ms('deployment').post(`threads`, thread, { 
			accounting: formValues.type == DeploymentThreadTypes.Custom ? rp.accountingProvider.a : -1 
		});
		return true;
	}
};
